// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Zj5R","col":"styles_col__2ujJI","fulfillmentStatus":"styles_fulfillmentStatus__2ohdw","emailCol":"styles_emailCol__2IsBy"};